export const BRAND_ICON_VERSION = "20260321-1";
export const BRAND_ICON_SRC = `/favicon.svg?v=${BRAND_ICON_VERSION}`;
